export default __webpack_public_path__ + "static/media/ladeboks.3b966633.svg";